"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = void 0;
const tslib_1 = require("tslib");
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
exports.sleep = sleep;
tslib_1.__exportStar(require("./crypto"), exports);
